import React, { useEffect } from 'react';

import TailwindcssBlock from 'components/Tailwindcss/Block';
import { ReactComponent as Logo } from 'images/clubes-logo.svg';
import { ReactComponent as Spinner } from 'images/animated-spinner.svg';

const BlockPageLoader = ({ className, style, valignTop, parentEl = document.body }) => {
  useEffect(() => {
    const originalClassName = String(parentEl.className);

    parentEl.className = originalClassName.replace(
      'bg-cgray',
      'transition-all transition-500 bg-gray-400',
    );

    return () => {
      parentEl.className = originalClassName;
    };
  }, [parentEl]);

  return (
    <TailwindcssBlock
      useDivTag
      flex
      justify-center
      py-6
      items-center={!valignTop}
      items-start={valignTop}
      className={className}
      style={style}
    >
      <div>
        <Logo />
        <TailwindcssBlock useDivTag mt-4>
          <Spinner className="w-10 h-10" />
        </TailwindcssBlock>
      </div>
    </TailwindcssBlock>
  );
};

export default BlockPageLoader;
